import React from 'react'
import ReactTooltip from 'react-tooltip'

import './Tooltip.scss'

const Tooltip = (...props) => {
  return (
    <ReactTooltip
      type='light'
      effect='solid'
      html
      className='react-tooltip'
      {...props}

    />
  )
}

export default Tooltip
